// aws-amplify-react's Authenticator passed every auth error through this map
// (AmplifyMessageMap) before showing it, so these short forms are the wording
// users have always seen -- e.g. Cognito's 'Incorrect username or password.'
// displayed without the full stop. v6 has no Authenticator; applying the same
// map here keeps the toast text unchanged across the migration.
const MESSAGE_MAP = [
  ['User does not exist', /user.*not.*exist/i],
  ['User already exists', /user.*already.*exist/i],
  ['Incorrect username or password', /incorrect.*username.*password/i],
  ['Invalid password format', /validation.*password/i],
  [
    'Invalid phone number format. Please use a phone number format of +12345678900',
    /invalid.*phone/i,
  ],
];

const mapMessage = (message) => {
  const entry = MESSAGE_MAP.find(([, test]) => test.test(message));
  return entry ? entry[0] : message;
};

// v6 raises `AuthError`, which carries the Cognito exception on `name`. v3 put
// it on `code`, which is why the old call sites all read `err.code`.
export const authErrorMessage = (err) => {
  if (!err) return 'Something went wrong';
  if (typeof err === 'string') return err;
  if (err.name === 'UserNotFoundException') {
    // Cognito's own wording leaks whether the account exists.
    return 'Invalid username or password';
  }
  return mapMessage(err.message || String(err));
};
